import React, { useEffect } from "react"
import * as S from './styles'
import * as G from '../../theme/global-styles'
import ClientLogo from "../../components/ClientLogo";
import PoweredByQITech from "../../components/PoweredByQITech";
import { QuestionMarkCircledIcon } from "@radix-ui/react-icons";
import { useThemeContext } from "../../contexts/ThemeContext";
import { setDatadogAction } from "../../services/datadog";

export const UnsupportedDevicePage = (props) => {
    const { isInvalidBrowser, isInvalidOS, signMetadata } = props;

    const { clientThemeSettings } = useThemeContext();

    useEffect(() => {
        setDatadogAction('An unsupported device accessed this app', {
            isInvalidBrowser,
            isInvalidOS,
            signMetadata
        });
    }, [isInvalidBrowser, isInvalidOS, signMetadata]);

    const messageType = isInvalidOS ? 'os' : isInvalidBrowser ? 'browser' : 'unknown';

    const title = messageType === 'os' ? 'Dispositivo incompatível' : messageType === 'browser' ? 'Navegador incompatível' : 'Dispositivo incompatível';
    
    const message = messageType === 'os' ? 'A versão do sistema operacional presente no seu dispositivo não é compatível com a plataforma de assinatura. Por favor, verifique se seu celular possui atualizações para serem instaladas ou realize a assinatura através de outro dispositivo celular.' :
    messageType === 'browser' ? 'A versão do navegador presente no seu dispositivo não é compatível com a plataforma de assinatura. Por favor, verifique se seu navegador possui atualizações para serem instaladas na loja de aplicativos.' :
    'O dispositivo que você está utilizando não é compatível com a plataforma de assinatura. Por favor, verifique se seu dispositivo possui atualizações para serem instaladas ou realize a assinatura através de outro dispositivo.';

    return (
        <G.Container>
            <S.Header>
                {clientThemeSettings?.logo_url ? (
                    <ClientLogo clientThemeSettings={clientThemeSettings} size='small' />
                ) : (
                    <></>
                )}
            </S.Header>
            <S.ExpiredContainer>
                <QuestionMarkCircledIcon color={clientThemeSettings?.background_color} width={32} height={32} />
                <G.Title>{title}</G.Title>
                <S.Description>{message}</S.Description>
            </S.ExpiredContainer>
            <S.Footer>
                <PoweredByQITech />
            </S.Footer>
        </G.Container>
    )
}